import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroBalanceCard = _resolveComponent("HeroBalanceCard")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_HeroBalanceCard, {
        label: _ctx.label,
        amount: _ctx.displayAmount,
        currencySymbol: _ctx.displayCurrency
      }, null, 8, ["label", "amount", "currencySymbol"])
    ])
  ]))
}